import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MdocsSopsService } from '../../services/mdocssops.services';
import { MdocsSopsmodel } from '../../models/mdocssops.models';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../../auth.service';
import { environment } from '../../../../environments/environment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-sops-list',
  templateUrl: './sops-list.component.html',
  styleUrls: ['./sops-list.component.css']
})
export class SopsListComponent implements OnInit {

  mdoclst: MdocsSopsmodel[] = []; unitId = 0; envurl = environment.waterMeter; closeResult: string;docDescription="";
  mdocSops=new MdocsSopsmodel();
  constructor(private router: Router, private messageService: MessageService,private modalService: NgbModal, private authService: AuthService, private mdocsService: MdocsSopsService) {
    this.unitId = this.authService.getUser().unitId; 
  }

  ngOnInit() {
    this.getList();
    this.mdocsService.MdocsSopsreatedObservable.subscribe((resp: boolean) => {
      if (resp) {
        this.getList();
      }
    });
  }
  getList() {
    this.mdocsService.GetMdocsSopsList(this.unitId,true).subscribe((resp: any) => {
      console.log(resp.MDocSopsDetails);
      this.mdoclst = resp.MDocSopsDetails;
    });
  }
  gotoUpload(){
    this.router.navigate(['sopsupload']);
  }
  openViewForm(content, docModel: MdocsSopsmodel) {
    this.mdocSops=docModel;
    this.modalService.open(content, { windowClass: "my-class" }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }

  }
}
